import { NotificationProvider } from '../../contexts/NotificationContext';
import NotificationContainer from '../../components/NotificationContainer';
import { Box } from '@mui/joy';
import { PageHeader } from '../../components/common/PageHeader';
import { SectionNavigation } from '../../components/common/SectionNavigation';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import TerritoriesList from './TerritoriesList';
import TerritoryDetail from './TerritoryDetail';
import AlertsList from './AlertsList';
import AlertDetail from './AlertDetail';

const watchlistsPath = '/advanced/storm-tracker/territories';

export default function StormTrackerApp() {
  const { pathname } = useLocation();
  return (
    <NotificationProvider><NotificationContainer /><Box sx={{ p: { xs: 1.5, md: 3 }, minWidth: 0 }}>
      <PageHeader title="Storm Tracker" description="Monitor storms near your leads and find the homeowners who need a follow-up." />
      <SectionNavigation label="Storm Tracker section" value={pathname.includes('/alerts') ? 'alerts' : 'territories'} options={[
        { value: 'territories', label: 'Watchlists', to: watchlistsPath },
        { value: 'alerts', label: 'Alert history', to: '/advanced/storm-tracker/alerts' },
      ]} />
    <Routes>
      <Route index element={<Navigate replace to={watchlistsPath} />} />
      <Route path="dashboard" element={<Navigate replace to={watchlistsPath} />} />
      <Route path="territories" element={<TerritoriesList />} />
      <Route path="territories/:id" element={<TerritoryDetail />} />
      <Route path="alerts" element={<AlertsList />} />
      <Route path="alerts/:id" element={<AlertDetail />} />
      <Route path="*" element={<Navigate replace to={watchlistsPath} />} />
    </Routes>
    </Box></NotificationProvider>
  );
}
